import { ContentBody } from "@app/components/core/ContentBody/ContentBody"
import { MultilineText } from "@app/components/core/MultilineText/MultilineText"
import Button from "@app/components/move2Library/Button/Button"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import Page from "@app/components/pageTypes/Page/Page"
import { useRaiseError } from "@app/store/actions/errorActions"
import { useGetStrings } from "@app/store/service/cmsService"
import { KioskBridge } from "@tecreation/bird5-kiosk-bridge"
import { useEffect, useRef } from "react"
import "./KioskSuccedPage.css"

export function KioskSucceedPage() {
	const {
		data: { orderSucceedTitle, kioskSucceedTextBlock, kioskReprintReceipt },
	} = useGetStrings(undefined, { defaultData: {} })
	const { push } = useCustomNavigation()
	const raiseError = useRaiseError()

	const timer = useRef(null)

	useEffect(() => {
		timer.current = setTimeout(() => {
			push("/kiosk-entrance")
		}, 20000)

		return () => clearTimeout(timer.current)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<div
			className="h-100"
			onClick={() => {
				push("/kiosk-entrance")
			}}
		>
			<Page className="">
				<ContentBody className="px-4 pt-8">
					<div className="color-fg-secondary mb-3 text-center f00">{orderSucceedTitle}</div>
					<div className="flex flex-center color-fg-green-700" style={{ fontSize: "200px" }}>
						<div className="success-animation" style={{ width: "250px", height: "250px" }}>
							<svg className="checkmark2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
								<circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
								<path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
							</svg>
						</div>
					</div>
					<div className="color-bg-green-100 p-3 f0 mt-8">
						<span className="color-fg-green-900 text-center">
							<MultilineText>{kioskSucceedTextBlock}</MultilineText>
						</span>
					</div>
				</ContentBody>
				<div className="w-100 flex flex-center mt-auto mb-8">
					<Button
						onClick={e => {
							clearTimeout(timer.current)
							timer.current = setTimeout(() => {
								push("/kiosk-entrance")
							}, 20000)
							e.stopPropagation()
							KioskBridge.execute("printer.kiosk.print.lastReceipt").catch(e => {
								raiseError(e instanceof Error ? e : new Error(e))
							})
						}}
						style="secondary"
						cssStyle={{ height: "80px" }}
						className="f2"
					>
						{kioskReprintReceipt}
					</Button>
				</div>
			</Page>
		</div>
	)
}
